<template>
  <div id="login">
    <div class="login-card">
      <div class="card-title">
        <img :src="logo" />
        <h1>{{ $t('login.title') }}</h1>
      </div>
      <div class="content">
        <form class="login" @submit.prevent="login">
          <input id="username"
            type="text"
            :placeholder="$t('login.username')"
            required
            autofocus
            v-model="username" />
          <input id="password"
            type="password"
            :placeholder="$t('login.password')"
            v-model="password"
            required />
          <div class="level options">
            <div class="checkbox level-left">
              <b-checkbox v-model="rememberme">
                {{ $t('login.rememberme') }}
              </b-checkbox>
            </div>
            <a class="btn btn-link level-right" href="#">Forgot Password?</a>
          </div>
          <button type="submit" class="button is-rounded is-large is-fullwidth">{{$t('login.submit')}}</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

import logo from '../kappazeta_logo.svg'

export default {
  data () {
    return {
      username : '',
      password : '',
      rememberme: false,
      logo: logo
    }
  },
  methods: {
    login: function () {
      const username = this.username
      const password = this.password
      const rememberme = this.rememberme
      this.$store.dispatch('login', { username, password, rememberme })
        .then((resp) => {
          this.$router.push('/')
        })
        .catch(err => {
          this.username = ''
          this.password = ''
        })
    }
  }
}

</script>

<style lang="stylus" scoped>

$primary =      hsl(171, 100%, 41%)
$grey-darker =  hsl(0, 0%, 21%)
$grey-dark =    hsl(0, 0%, 29%)
$grey =         hsl(0, 0%, 48%)
$grey-light =   hsl(0, 0%, 71%)
$grey-lighter = hsl(0, 0%, 86%)

#login
  display: flex
  align-items: center
  justify-content: center
  height: 100vh
  background: #F7F7F7

  .login-card
    background: #fff
    width: 24rem
    box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11)

    .card-title
      background-image: linear-gradient(to right, #1CA554, #1257A4)
      padding: 2rem

      h1
        color: #fff
        text-align: center
        font-size: 1.2rem

    .content
      padding: 3rem 2.5rem 5rem

    #username, #password
      display: block
      width: 100%
      font-size: 1rem
      margin-bottom: 1.75rem
      padding: 0.25rem 0
      border: none
      border-radius: 0
      border-bottom: 1px solid $grey-lighter
      transition: all .5s
      box-shadow: none

      &:hover
        border-color: $grey

      &:active, &:focus
        border-color: $primary
        box-shadow: none

    .checkbox
      color: $grey-light
      font-size: 0.8rem

      span
        margin-left: 0.5rem

    a
      font-size: 0.8rem

    .options
      color: $grey-light
      margin-bottom: 1.5rem

    button
      cursor: pointer
      color: $primary
      border: 2px solid $primary
      transition: color .5s, border-color .5s

      &:hover, &:focus
        color: darken($primary, 10%)
        border-color: darken($primary, 10%)

      &:active
        transform: translateY(1px)

label
  cursor: pointer

.regular-checkbox
  display: none

.regular-checkbox + label
  background-color: #fafafa
  border: 1px solid $grey-lighter
  box-shadow: 0 1px 2px rgba(0,0,0,0.05)
  padding: 7px
  border-radius: 3px
  display: inline-block
  position: relative

.regular-checkbox:checked + label
  background-color: #e9ecee

.regular-checkbox:checked + label:after
  content: '\2714'
  font-size: 11px
  position: absolute
  top: 0
  left: 3px
  color: $grey-light

input:focus,
select:focus,
textarea:focus,
button:focus
  outline: none

</style>
